import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Image, Col, Container, Row, Card, CardBody } from "react-bootstrap";
import client1 from "../images/clients/punjabpolice.png";
import client2 from "../images/clients/traficpolice.png";
import client3 from "../images/clients/citycollege.png";
import client4 from "../images/clients/shangrilla.png";
import client5 from "../images/clients/finead.png";
import client6 from "../images/clients/jadeedbazar.png";
import client7 from "../images/clients/jadeedems.png";
import client8 from "../images/clients/jadeedmunshi.png";

const ClientSlider = () => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 5000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const data = [
    { client: client1, alt: "Pakistan Punjab Police" },
    { client: client2, alt: "Trafic Police Punjab" },
    { client: client3, alt: "City College" },
    { client: client4, alt: "Shangrilla " },
    { client: client5, alt: "FineAd" },
    { client: client6, alt: "Jadeed Bazar" },
    { client: client7, alt: "Jadeed Education Management System" },
    { client: client8, alt: "Jadeed Munshi" },
  ];

  return (
    <section className="clients-slider section-bg">
      <Container>
        <Row>
          <Slider {...settings}>
            {data.map((logo, index) => (
              <Col
                key={index}
                xs={12}
                md={4}
                lg={3}
                className="hvr-float-shadow"
              >
                <Image src={logo.client} alt={logo.alt} />
              </Col>
            ))}
          </Slider>
        </Row>
      </Container>
      </section>
  );
};

export default ClientSlider;
